module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.user) ? _c('md-button', {
    on: {
      "click": _vm.onClickLogin
    }
  }, [_vm._v("Login")]) : _c('md-button', {
    on: {
      "click": _vm.onClickLogout
    }
  }, [_vm._v("Logout")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d0b52aba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginButton.vue
// module id = 105
// module chunks = 2